import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Compteur des requêtes POST / PUT / PATCH / DELETE en cours (voir `HTTP_BTN_LOADING_METHODS`).
 * `BtnHttpLoadingDirective` met les `button.btn` en `disabled` lorsque ce compteur &gt; 0.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpLoadingService {
  private readonly _pending = new BehaviorSubject<number>(0);

  readonly pending$: Observable<number> = this._pending.asObservable();

  get pendingCount(): number {
    return this._pending.value;
  }

  begin(): void {
    this._pending.next(this._pending.value + 1);
  }

  end(): void {
    this._pending.next(Math.max(0, this._pending.value - 1));
  }
}
